// src/utils/currencyMeta.js
import countries from "world-countries";
import currencyCodes from "currency-codes";

export const currencyOptions = countries
  .map((country) => {
    // Ensure currencies exist
    const currencyKeys = country.currencies ? Object.keys(country.currencies) : [];
    const firstCurrency = currencyKeys.length > 0 ? currencyKeys[0] : null;

    if (!firstCurrency) return null; // skip countries without currency

    const currencyInfo = currencyCodes.code(firstCurrency);

    return {
      code: firstCurrency.toUpperCase(),
      name: currencyInfo ? currencyInfo.currency : firstCurrency,
      flag: country.cca2?.toLowerCase() || "un", // fallback "un" for undefined
      country: country.name.common,
    };
  })
  .filter(Boolean)
  // Remove duplicates by currency code
  .reduce((unique, curr) => {
    if (!unique.some((c) => c.code === curr.code)) unique.push(curr);
    return unique;
  }, [])
  // Sort alphabetically for consistency
  .sort((a, b) => a.code.localeCompare(b.code));
